module.exports = __webpack_public_path__ + "img/labmemtest_text_btn02_sc.bff65c09.png";